import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface FieldMappingField {
  fieldKey: string;
  label: string;
  required: boolean;
}

@Component({
  selector: 'app-field-mapping',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './field-mapping.component.html',
  styleUrl: './field-mapping.component.scss',
})
export class FieldMappingComponent {
  @Input() fields: FieldMappingField[] = [];
  @Input() columns: string[] = [];
  @Input() sourceLabel = 'Source Field';
  @Input() placeholder = 'Select Field';
  @Input() mappings: Record<string, string> = {};
  @Input() showRequiredMark = true;
  @Input() filledSelect = false;
  @Input() idPrefix = 'field-map';

  trackField(_index: number, field: FieldMappingField): string {
    return field.fieldKey;
  }
}
